import "./BackgroundCard.scss";

const BackgroundCard = ({ className = "", children }) => {
    return <div className={`BackgroundCard ${className}`}>{children}</div>;
};

export default BackgroundCard;
